let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kLHDj")).then(() => parcelRequire('8Ip33'));